export default __webpack_public_path__ + "static/media/warrow_left-01.ab01fbc6.svg";